import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/AdminLogin.css';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [formError, setFormError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  const { login, error: authError, setError } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    setError('');
  }, [setError]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      setFormError('Veuillez entrer une adresse e-mail et un mot de passe.');
      return;
    }

    if (!email.includes('@')) {
      setFormError('Veuillez entrer une adresse e-mail valide.');
      return;
    }

    setFormError('');
    setIsLoading(true);

    const result = await login(email, password);
    
    if (result.success) {
      navigate('/admin/dashboard');
    } else {
      setFormError(result.message);
    }
    
    setIsLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <div className="login-logo">
              <img src="/dgpLogo.jpg" alt="DGP Logo" className="logo-img-login" />
              <h2>Portail Administrateur</h2>
            </div>
            <p>Connectez-vous pour gérer les informations des pèlerins</p>
          </div>
          
          <form onSubmit={handleSubmit} className="login-form">
            {(formError || authError) && (
              <div className="error-message login-error animate-fade-in">
                {formError || authError}
              </div>
            )}
            
            <div className="form-group">
              <label htmlFor="email">Adresse E-mail</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@exemple.com"
                disabled={isLoading}
                required
                autoFocus
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="password">Mot de Passe</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Entrez votre mot de passe"
                disabled={isLoading}
                required
              />
            </div>
            
            <button 
              type="submit" 
              className="login-button"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner" style={{width: '20px', height: '20px', borderWidth: '3px'}}></span>
                  Connexion en cours...
                </>
              ) : (
                'Se Connecter'
              )}
            </button>
            
            {/* <div className="login-help" style={{marginTop: '1rem', fontSize: '0.85rem', color: '#64748b', textAlign: 'center'}}>
              <p>Identifiants par défaut :</p>
              <p className="credentials" style={{fontWeight: '600', color: '#0f172a'}}>admin@example.com / admin123</p>
            </div> */}
          </form>
          
          <div className="login-footer">
            <Link to="/" className="back-link">
              ← Retour au Portail Public
            </Link>
            <div className="support-info" style={{marginTop: '0.5rem', color: '#64748b'}}>
              Besoin d'aide ? Contactez l'administrateur système.
            </div>
          </div>
        </div>
        
        <div className="login-sidebar">
          <div className="sidebar-content">
            <h3>Fonctionnalités Admin</h3>
            <ul className="features-list">
              <li>✅ Ajouter de nouveaux de pèlerins</li>
              <li>✅ Éditer les informations existantes</li>
              <li>✅ Supprimer des pèlerins</li>
              <li>✅ Rechercher et filtrer facilement</li>
              <li>✅ Authentification sécurisée</li>
            </ul>
            <div className="security-note">
              <span className="security-icon">🛡️</span>
              <p>Toutes les actions sont enregistrées pour des raisons de sécurité.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;